export const specializedProductCollectionGuard = 'GET /specialized_products';
